import React, { useState, useEffect } from 'react';
import { Page, SearchBar } from 'components';
import { Results } from './components';
import { useHistory } from 'react-router-dom';
import { Col, Row, Button, Modal } from 'react-bootstrap';
import Reload from '../../components/Reload/Reload';
import Header from '../../components/Header/Header';
import NotifyModal from '../../components/NotifyModal/NotifyModal';
import ApiMServer from 'services/ApiMServer';
import { loadState, saveState } from 'utils/persistState';
import { useAppTheme } from '../../contexts/ThemeContext';
import { matchesCompanySearch } from 'utils/searchMatch';

const UnitsClass = () => {
  const history = useHistory();

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.units?.read !== true) {
    window.location.replace('/home');
  }

  const [units, setUnits] = useState([]);
  const [unitsToShow, setUnitsToShow] = useState([]);
  const [open, setOpen] = useState(false);
  const [searchData, setSearchData] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [loading, setLoading] = useState(true);

  const STORAGE_KEY = 'filters:units';

  const [type, setType] = useState({ color: "", status: "" });
  const [modalShow, setModalShow] = useState(false);

  const currentTheme = useAppTheme();

  // Load persisted search on mount
  useEffect(() => {
    const persisted = loadState(STORAGE_KEY, null);
    if (persisted && typeof persisted.searchData === 'string') {
      setSearchData(persisted.searchData);
    }
  }, []);

  // Persist on change
  useEffect(() => {
    saveState(STORAGE_KEY, { searchData });
  }, [searchData]);

  const handleAlertModalSuccess = (msg) => {
    setType({ color: "#198754", status: msg })
    setModalShow(true)
  }

  const handleAlertModalError = (msg) => {
    setType({ color: "red", status: msg })
    setModalShow(true)
  }

  const handleClickOpen = (id) => {
    setCompanyId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setCompanyId('');
    setOpen(false);
  };

  const getUnits = async () => {
    try {
      const { data: units } = await ApiMServer.get(`/company/v1/getunits`);
      let sortUnits = units.sort((a, b) => {
        if (a.name === b.nameD)
          return 0;
        if (a.name < b.name)
          return -1;
        if (a.name > b.name)
          return 1;
      });
      setLoading(false)
      setUnits(sortUnits);
      setUnitsToShow(sortUnits);
    } catch (error) {
      console.log(error);
      setLoading(false)
    }
  };

  const removeUnit = async () => {
    setOpen(false);
    try {
      await ApiMServer.post('/company/delete', { id: companyId });
      getUnits();
      handleAlertModalSuccess('Removido com Sucesso!');
    } catch (e) {
      handleAlertModalError('Falha ao Remover!');
    }
  };

  useEffect(() => {
    getUnits()
  }, [])

  const handleSearch = () => {
    if (!searchData.trim()) {
      setUnitsToShow(units);
      return;
    }

    const term = searchData.trim();
    setUnitsToShow(units.filter((item) => matchesCompanySearch(item, term)));
  };

  // Auto-apply when data/search changes
  useEffect(() => {
    handleSearch();
  }, [units, searchData]);

  const handleSearchData = (e) => {
    setSearchData(e.target.value)
  };

  const handleClick = () => {
    history.push('/units/add');
  };

  const handleReport = () => {
    if (!unitsToShow || unitsToShow.length === 0) return;
    const headers = ['ncontract', 'name', 'cnpj', 'address', 'equipment'];
    const csvRows = [headers.join(',')];
    unitsToShow.forEach(unit => {
      // Primeira linha: dados da empresa, campo equipment vazio
      const rowEmpresa = [unit.ncontract || '', unit.name || '', unit.cnpj || '', unit.address || '', ''];
      csvRows.push(rowEmpresa.map(v => `"${String(v).replace(/"/g, '""')}` + '"').join(','));
      // Linhas seguintes: apenas equipamentos
      const equipments = Array.isArray(unit.equipments) ? unit.equipments : (unit.equipments ? [unit.equipments] : []);
      equipments.forEach(equipment => {
        const row = ['', '', '', '', equipment || ''];
        csvRows.push(row.map(v => `"${String(v).replace(/"/g, '""')}` + '"').join(','));
      });
      // Linha em branco para separar empresas
      csvRows.push('');
    });
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'units_report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  return (
    <Page className="p-3" title="Unidades">
      <Header page={'Unidades'} />

      {loading && <Reload />}

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Row className="align-items-center g-2">
        <Col xs={8} sm={6} md={6} lg={6} xl={6} xxl={6}>
          <SearchBar
            onSearch={handleSearch}
            onSearchData={handleSearchData}
            searchData={searchData}
          />
        </Col>
        <Col xs={4} sm={6} md={6} lg={6} xl={6} xxl={6} className="text-md-end text-center">
          <Button
            className='me-2'
            disabled={!user?.permission?.cooperatives?.write}
            onClick={handleReport}
            variant="success"
          >
            Relatório
          </Button>
          <Button
            disabled={!user?.permission?.units?.write}
            onClick={handleClick}
            variant="success"
          >
            Adicionar Unidade
          </Button>
        </Col>
      </Row>

      {unitsToShow && (
        <Results
          user={user}
          data={unitsToShow}
          currentTheme={currentTheme}
          onRemoveButton={handleClickOpen}
        />
      )}

      <Modal
        show={open}
        onHide={handleClose}
        contentClassName={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}
      >
        <Modal.Header
          closeButton
          className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}
        >
          <Modal.Title>
            Remover
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={currentTheme === 'dark' ? 'bg-dark text-light' : 'bg-light text-dark'}>
          Confirma Remover a Empresa?
        </Modal.Body>
        <Modal.Footer className={currentTheme === 'dark' ? 'bg-dark text-light border-secondary' : 'bg-light text-dark'}>
          <Button variant="secondary" onClick={handleClose}>
            Não
          </Button>
          <Button variant="danger" onClick={removeUnit}>
            Sim
          </Button>
        </Modal.Footer>
      </Modal>

    </Page>
  );
};

export default UnitsClass;
